import moment from 'moment';

const Helpers = {
    install: (app) => {
        
        /* dateFormat */
        app.config.globalProperties.$dateFormat = function (date) {
            const publishedAt = moment(date);
            const today = moment();

            if (publishedAt.isSame(today, 'day')) {
                return `Hoje às ${publishedAt.format('HH:mm')}`;
            } else if (publishedAt.isSame(today, 'yesterday')) {
                return `Ontem às ${publishedAt.format('HH:mm')}`;
            } else if (publishedAt.format('HH:mm') === "00:00") {
                return publishedAt.format('DD/MM/YYYY');
            } else {
                return publishedAt.format('DD/MM/YYYY [às] HH:mm');
            }
        }

        /* moneyFormat */
        app.config.globalProperties.$moneyFormat = function(value) {
            if(!value){
                value = 0;
            }

            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        };

        /* numberFormat */
        app.config.globalProperties.$numberFormat = function(value) {
            if(!value){
                value = 0;
            }

            return new Intl.NumberFormat('pt-BR').format(value);
        };
    }
};

export default Helpers;